import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { initialJoinCommuteState } from '../JoinCommuteReducer';
import { getFullPrice } from '../helpers/vanHelpers';
import { Link } from 'react-router-dom';
import ArrowLeft from '../../_styles/images/ArrowLeft.png';
import { UPDATE_START_DATE, GET_PRORATED_AMOUNT, UPDATE_CHANGE_START_DATE, UPDATE_PAYMENT_CARDS } from '../../redux/actionTypes';
import { addDays,getDaysFromRosterDays,numberWithCommas, getPlan } from '../helpers/commonHelper';
import ImageNotAvailable from '../../_styles/images/ImageNotAvailable.svg';
import analyticsService from '../../shared/analytics/analytics-service';
import Calendar, { MONTHS } from '../../shared/inputs/Calendar/Calendar';
import { getTomorrowsDate } from '../../shared/helpers/dateHelpers';
import dateUtility from '../../shared/dateUtility';
import Loading from '../../shared/loading/Loading';
import ImageNotAvailableNoCross from '../../_styles/images/Img_not_available_no_cross.png';

function ChangeStartDate(props) {

  const [selectedVan, updateSelectedvan] = useState({});
  const [vanCharge, updateVanCharge] = useState();
  const [rideDays, updateRideDays] = useState([]);
  const [selectedDay, updateSelectedDay] = useState();
  const [selectedDayString, updateSelectedDayString] = useState();
  const [buttonDisabled, updateButtonDisabled] = useState(true);
  const [isOpen, updateIsOpen] = useState(false);
  const [enabledDays, updateEnabledDays] = useState([]);
  const tomorrow = getTomorrowsDate();
  const [startDay, updateStartDay] = useState(tomorrow);
  const [endDay, updateEndDay] = useState(new Date(new Date().setHours(0, 0, 0, 0)));
  const [isLoading, updateIsLoading] = useState(false);

  const node = useRef(null);
  const dateNode = useRef(null);

  useEffect(() => {
    if (isEqual(props.joinCommuteData, initialJoinCommuteState)) {
      props.history.push("/JoinCommute");
    }
  }, [])

  useEffect(() => {
    if (props.joinCommuteData) {
      if (props.joinCommuteData.selectedVan) {
        updateSelectedvan(props.joinCommuteData.selectedVan);
      }
      if(props.summaryData){
        const summaryTotal = getFullPrice(props.summaryData.totalAmount);
        updateVanCharge({...summaryTotal, rate: props.summaryData.subscriptionRate});
      }
      var rosterDays = props.joinCommuteData.userCommuteData.rosterDays;
      var ridedays = Object.keys(rosterDays).filter((d) => rosterDays[d]);
      updateRideDays(ridedays);
      let startDay = dateUtility.getToday();
      let endDay = dateUtility.getToday();
      if (props.recommendedStartRange && props.recommendedStartRange.start && props.recommendedStartRange.end) {
        startDay = dateUtility.getLocaldate(props.recommendedStartRange.start);
        endDay = dateUtility.getLocaldate(props.recommendedStartRange.end);
        updateStartDay(startDay);
        updateEndDay(endDay);
      }
      if (props.joinCommuteData && props.joinCommuteData.userCommuteData && props.joinCommuteData.userCommuteData.changeStartDate) {
        const convertedDate = dateUtility.getLocaldate(props.joinCommuteData.userCommuteData.changeStartDate);
        updateSelectedDay(convertedDate);
      }
    }
  }, [props.joinCommuteData]);


  useEffect(() => {
    if (selectedDay) {
      updateButtonDisabled(false);
    } else {
      updateButtonDisabled(true);
    }
  }, [selectedDay])

  useEffect(() => {
    const days = getDaysFromRosterDays(rideDays);
    updateEnabledDays(days);
  }, [rideDays])

  function onContinue() {
    const startDateString = dateUtility.getDateStringFromDay(selectedDay);
    props.updateCangeStartDate({ startDate: selectedDay, startDateString});
   // props.updateStartDate({ startDate: null, startDateString: null})
    var fromChangeStartDate = true;
   if(props.joinCommuteData.payment.cards && props.joinCommuteData.payment.cards.length > 1){
    const updatedArray = props.joinCommuteData.payment.cards.filter(card => !card.isBackup);
    props.updatePaymentCards(updatedArray && updatedArray[0]);
   }
   analyticsService.analyticsProcessEvent({
    "event": "click_generic",
    "context": {
      "event_action": "continue"
    }
  });
    updateIsLoading(true);
    props.getProratedAmount(fromChangeStartDate,props.history);
  }

  function checkAndCloseCalendar() {
    const modal = document.getElementById("modal");
    const classes = Array.from(modal.classList);
    if (classes.includes('show')) {
      const all = document.querySelector(".left-content");
      all.setAttribute("aria-hidden", "false");
      updateIsOpen(false);
    }
  }

  function toggleCalendar() {
    if (!isOpen) {

      const modal = document.getElementById("modal");
      // Hide the background page with ARIA
      const all = document.querySelector(".left-content");
      all.setAttribute("aria-hidden", "true");

      // Add the classes and attributes to make the modal visible
      updateIsOpen(true);
      modal.setAttribute("aria-modal", "true");
      modal.querySelector(".calendar-day").focus();

      analyticsService.analyticsProcessEvent({
        "event": "click_generic",
        "context": {
          "event_action": "select start date"
        }
      });
      analyticsService.analyticsProcessEvent({
        "event": "start_date_modal_view",
        "context": {
          "event_action": "start date modal"
        }
      })
    } else {
      const all = document.querySelector(".left-content");
      all.setAttribute("aria-hidden", "false");
      updateIsOpen(false);
      setTimeout(() => {
        dateNode?.current?.focus();
      }, 500)
    }
  }

  function onCalendarKeydown(e) {
    if (e.which == 13) {
      toggleCalendar();
    }
  }

  const clickOutside = (e) => {
    if (node.current.contains(e.target)) {
      return;
    }
    toggleCalendar();
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', clickOutside);
      return () => {
        document.removeEventListener('mousedown', clickOutside);
      }
    }
  }, [isOpen])

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        checkAndCloseCalendar()
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, []);

  return (
    <div className='change-start-date-container'>
        <Loading isLoading={isLoading} />
      <div className="change-start-date-page">
        <div className='header'>
          <div className='backArrow'>
            <Link className="overview-link" onClick={props.history.goBack}>
              <img alt='go back' src={ArrowLeft}></img>
            </Link>
          </div>
          <div className='heading'>Change Start Date</div>
        </div>
        <div className='sub-heading'>
        Choose a start date when your Federal Card will be funded to cover the monthly cost of your subscription. Moving your start date to the following month will help avoid using a secondary payment card to cover your first payment.
        </div>
        <div className="change-start-date-content">
          <div className='left-content'>
          <div className="vanpool-Details">
              <div className="van-details" role='group'>
                <div className="van-class-details" role='group'>
                  <div className="van-class">{selectedVan.vehicleClass}</div>
                  {/* <div className="van-model">{selectedVan.ymms}</div> */}
                </div>
                <div className="van-price-details" role='group'>
                  {vanCharge && <div className='price-group' aria-label={`${vanCharge.price} dollars and ${vanCharge.decimal} cents`}>
                    <div className="doller">{'$'}</div>
                    <div className="price">{numberWithCommas(vanCharge.price)}</div>
                    <div className="decimal">.{vanCharge.decimal}</div>
                  </div>}
                  <div className="sub">{"total per month"}</div>
                </div>
              </div>
            </div>
            {/* calendar */}
            <div className="vanpool-summary-plan">
            <div className="van-datePicker" role='region' aria-labelledby="plan-heading">
              <h2 id="plan-heading" className="screenreader-only">Vanpool Plan Summary</h2>
              <div className="plan-heading">
                {props.joinCommuteData.plan.noOfDays >= 5 ? "Unlimited Plan" : `${getPlan(props.joinCommuteData.plan.noOfDays)}-Day Plan`}
              </div>
              <div className='picker-container'>
                <label id="start-date-label" htmlFor="start-date-picker">Your Start Date*</label>
                <button id="start-date-picker"  aria-labelledby="start-date-label start-date-description" ref={dateNode} className='picker' onClick={toggleCalendar} role='button' onKeyDown={onCalendarKeydown} aria-expanded={isOpen} aria-haspopup="dialog">
                  {selectedDay ?
                    <div className='date-display' id="start-date-description">
                      <div className='day'>{selectedDay.getDate()}</div>
                      <div className='month'>{MONTHS[selectedDay.getMonth()]}</div>
                      <div className='year'>{selectedDay.getFullYear()}</div>
                    </div>
                    :
                    <div className='placeholder' id="start-date-description">
                      <span className='text'>Select Start Date</span>
                    </div>
                  }
                  <i className="time-arrow down"  aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div aria-live='polite' role='alert' id='modal' className={"popup" + (isOpen ? " show" : " hide")}>
          <Calendar
            reference={node}
            buttonText={'confirm start date'}
            toggle={toggleCalendar}
            enabledDays={enabledDays}
            selectedDay={selectedDay}
            onConfirm={updateSelectedDay}
            startDay={startDay}
            endDay={endDay}
            reset={isOpen}
            changeStartDate={true}
          />
        </div>
          </div>
          <div className='right-content'>
          <div className="vanpool-summary-image">
                        <div className="van-Image">
                          <div className={`${selectedVan.isPredelivery ? 'car-image-opacity' : 'car-image'}`}>
                            <img src={selectedVan.carClassImage} onError={e => {
                              e.currentTarget.src = ImageNotAvailableNoCross;
                              e.currentTarget.className = "image-not-found";
                            }} alt='van image' />
                          </div>
                        </div>
                      </div>
          </div>
        </div>

        <div className='button-container'>
          <button className='continue-button' onClick={onContinue} disabled={buttonDisabled}>Continue</button>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    joinCommuteData: state.joinCommute,
    summaryData: state.joinCommute.userCommuteData && state.joinCommute.userCommuteData.summaryData,
    recommendedStartRange: state.joinCommute.payment.recommendedStartRange,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    updateCangeStartDate(date) {
      dispatch({ type: UPDATE_CHANGE_START_DATE, data: date });
    },
    updateStartDate(date) {
      dispatch({ type: UPDATE_START_DATE, data: date });
    },
    updatePaymentCards(data) {
      dispatch({ type: UPDATE_PAYMENT_CARDS, data: data });
    },
    getProratedAmount(fromChangeStartDate, history) {
      dispatch({
        type: GET_PRORATED_AMOUNT,
        fromChangeStartDate,
        history
      })
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeStartDate)